import {
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "ui/components/sidebar";
import { Link, useLocation } from "react-router-dom";
import { usePermissions } from "contexts/permission";

export function NavSubItem({
  title,
  url,
  requiredPermissions,
  className = "",
  ...props
}) {
  const permissions = usePermissions();
  const location = useLocation();

  const isActive = url ? location.pathname.startsWith(`${url}`) : false;

  if (!permissions.evaluatePermission(requiredPermissions)) {
    return null;
  }

  return (
    <SidebarMenuSubItem>
      <SidebarMenuSubButton
        asChild
        className={className}
        data-active={isActive}
        {...props}
      >
        <Link to={url}>
          <span>{title}</span>
        </Link>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  );
}
